import { render } from "./UserActionsPopover.vue?vue&type=template&id=7bc3f7f8&ts=true"
import script from "./UserActionsPopover.vue?vue&type=script&lang=ts"
export * from "./UserActionsPopover.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__